/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateFormTemplateRequest
 */
export interface CreateFormTemplateRequest {
    /**
     * Template name
     * @type {string}
     * @memberof CreateFormTemplateRequest
     */
    name: string;
    /**
     * Template description
     * @type {string}
     * @memberof CreateFormTemplateRequest
     */
    description?: string;
    /**
     * Template category
     * @type {string}
     * @memberof CreateFormTemplateRequest
     */
    category?: string;
    /**
     * Display order
     * @type {number}
     * @memberof CreateFormTemplateRequest
     */
    displayOrder?: number;
    /**
     * Base64-encoded PDF file
     * @type {string}
     * @memberof CreateFormTemplateRequest
     */
    pdfFile: string;
}

/**
 * Check if a given object implements the CreateFormTemplateRequest interface.
 */
export function instanceOfCreateFormTemplateRequest(value: object): value is CreateFormTemplateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('pdfFile' in value) || value['pdfFile'] === undefined) return false;
    return true;
}

export function CreateFormTemplateRequestFromJSON(json: any): CreateFormTemplateRequest {
    return CreateFormTemplateRequestFromJSONTyped(json, false);
}

export function CreateFormTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateFormTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'category': json['category'] == null ? undefined : json['category'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'pdfFile': json['pdfFile'],
    };
}

export function CreateFormTemplateRequestToJSON(json: any): CreateFormTemplateRequest {
    return CreateFormTemplateRequestToJSONTyped(json, false);
}

export function CreateFormTemplateRequestToJSONTyped(value?: CreateFormTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'category': value['category'],
        'displayOrder': value['displayOrder'],
        'pdfFile': value['pdfFile'],
    };
}

